import Swiper from "swiper/bundle";
import "swiper/css/bundle";

/**
 * Layout: Ondernemers overzicht
 * Slug: ondernemer_overview
 */

const SPEED = 7000;

// A loop with auto-width slides needs more slide width than the viewport, so short rows are repeated first
const fillRow = (swiperEl) => {
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    const originals = [...wrapper.children];
    if (!originals.length) return;

    const sum = () => [...wrapper.children].reduce((width, slide) => width + slide.offsetWidth, 0);
    const target = window.innerWidth * 2;

    while (sum() < target && wrapper.children.length < 60) {
        originals.forEach((slide) => {
            const copy = slide.cloneNode(true);
            copy.setAttribute("aria-hidden", "true");
            copy.setAttribute("inert", "");
            wrapper.appendChild(copy);
        });
    }
};

// Swiper's own loop clones are hidden from assistive tech too
const hideDuplicates = (swiper) => {
    swiper.el.querySelectorAll(".swiper-slide-duplicate").forEach((slide) => {
        slide.setAttribute("aria-hidden", "true");
        slide.setAttribute("inert", "");
    });
};

// Swiper's pauseOnMouseEnter lets the running slide finish (up to SPEED long), so freeze the row in place instead
const holdOnPause = (swiper) => {
    const state = { hovered: false, visible: true, resumeWhenDone: null };

    const freeze = () => {
        if (state.resumeWhenDone) swiper.off("transitionEnd", state.resumeWhenDone);
        state.resumeWhenDone = null;
        if (!swiper.autoplay.running) return;

        const current = swiper.getTranslate();
        swiper.autoplay.stop();
        swiper.setTransition(0);
        swiper.setTranslate(current);
    };

    // Finish the interrupted slide at the same pace, then let autoplay carry on
    const resume = () => {
        if (swiper.autoplay.running) return;

        const slideSize = swiper.virtualSize / swiper.slides.length;
        const distance = Math.abs(swiper.getTranslate() - swiper.snapGrid[swiper.activeIndex] * -1);

        if (distance < 1 || !slideSize) {
            swiper.autoplay.start();
            return;
        }

        state.resumeWhenDone = () => {
            state.resumeWhenDone = null;
            swiper.autoplay.start();
        };
        swiper.once("transitionEnd", state.resumeWhenDone);
        swiper.slideTo(swiper.activeIndex, SPEED * (distance / slideSize));
    };

    const sync = () => (state.visible && !state.hovered ? resume() : freeze());

    swiper.el.addEventListener("mouseenter", () => {
        state.hovered = true;
        sync();
    });
    swiper.el.addEventListener("mouseleave", () => {
        state.hovered = false;
        sync();
    });

    // No need to animate rows that are off screen
    new IntersectionObserver(([entry]) => {
        state.visible = entry.isIntersecting;
        sync();
    }).observe(swiper.el);
};

const initOndernemerOverview = () => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    document.querySelectorAll(".ondernemer_overview-layout").forEach((layout) => {
        layout.querySelectorAll(".ondernemer-swiper").forEach((el) => {
            fillRow(el);

            const swiper = new Swiper(el, {
                loop: true,
                slidesPerView: "auto",
                speed: SPEED,
                grabCursor: true,
                allowTouchMove: true,
                autoplay: reduceMotion
                    ? false
                    : {
                          delay: 0,
                          disableOnInteraction: false,
                          reverseDirection: el.dataset.direction === "right",
                      },
                on: {
                    init: hideDuplicates,
                    loopFix: hideDuplicates,
                },
            });

            if (!reduceMotion) holdOnPause(swiper);
        });
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOndernemerOverview);
} else {
    initOndernemerOverview();
}
